export { default } from '@esentai/core/features/products/api';
